import SECOND_LEVEL_DOMAINS from './second_level_domains.yml'

/**
 * This function checks if a given domain is a second level domain.
 * Uses SECOND_LEVEL_DOMAINS, but it does not cover the entire spectre of ccTLDs & GeoTLDs, only a few of them.
 * @param {string} domain - The domain to check.
 * @returns {boolean} Returns true if the domain is a second level domain, otherwise returns false.
 *
 * @example
 * isSecondLevelDomain('calendly.com') // false
 * isSecondLevelDomain('sub.example.co.uk') // true
 * isSecondLevelDomain('www.calendly.com') // false
 */
const isSecondLevelDomain = (domain) => {
  const tld = `.${domain.split('.').slice(-1)[0]}`
  const secondLevelDomain = SECOND_LEVEL_DOMAINS[tld]
  if (secondLevelDomain) {
    const fullDomain = `.${domain.split('.').slice(-2).join('.')}`
    return secondLevelDomain.includes(fullDomain)
  }
  return false
}

/**
 * Checks if a given domain contains any subdomains.
 *
 * @param {string} domain - The domain name to check.
 * @returns {boolean} Whether or not the provided domain contains any subdomains.
 */
export const hasSubdomain = (domain) => {
  let lengthOfDomainNameAndExtension = 2
  if (isSecondLevelDomain(domain)) {
    lengthOfDomainNameAndExtension = 3
  }
  const subdomains = domain.split('.').slice(0, -lengthOfDomainNameAndExtension)

  return subdomains.length > 0
}
